module.exports = __webpack_public_path__ + "img/img_charge_img4.cd48f836.png";